import { inject, Injectable } from '@angular/core';
import { MatIconRegistry, SafeResourceUrlWithIconOptions } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class IconsService {
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly iconRegistry = inject(MatIconRegistry);

  constructor() {
    this.iconRegistry.addSvgIconResolver(
      (name: string, namespace: string): SafeResourceUrl | SafeResourceUrlWithIconOptions | null => {
        switch (namespace) {
          case 'mat':
            return this.domSanitizer.bypassSecurityTrustResourceUrl(
              `assets/img/icons/material-design-icons/two-tone/${name}.svg`
            );

          case 'outlined':
            return this.domSanitizer.bypassSecurityTrustResourceUrl(
              `assets/img/icons/material-design-icons/outlined/${name}.svg`
            );

          case 'filled':
            return this.domSanitizer.bypassSecurityTrustResourceUrl(
              `assets/img/icons/material-design-icons/filled/${name}.svg`
            );

          case 'logo':
            return this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/img/icons/logos/${name}.svg`);

          case 'flag':
            return this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/img/icons/flags/${name}.svg`);

          case 'flag-cdn':
            return this.domSanitizer.bypassSecurityTrustResourceUrl(`https://flagcdn.com/${name}.svg`);

          case 'remix':
            return this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/img/icons/remixicon/${name}.svg`);

          default:
            return null;
        }
      }
    );
  }
}
